import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  getDoc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomnumber } from "../components_root/rendom_number"; 

export const Createcompany = async (data) => {
  const { company, serviceid, servicetablename, companyuid } = data || {};

  // 1. Validate inputs
  if (!company?.trim()) {
    return { success: false, error: "Missing company" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {

    const tablename = "companies";
    // ✅ Check if domain already exists for this user
    const domainQuery = query(
      collection(db, tablename),
      where("status", "==", false),
      where("guid", "==", guid)
    );
    const snapshot = await getDocs(domainQuery);
    if (!snapshot.empty) {
      return { success: false, error: "You have already an existing company waiting to activate" };
    }
    // ✅ Save parent document

    const parentDocRef = doc(db, tablename, companyuid);
    const savequery = {
      ...data,
      status: true,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(parentDocRef, savequery);
    //
    const serviceDocRef = doc(
      db,
      "companies",
      companyuid,
      servicetablename,
      serviceid
    );

    const servicequery = {
      ...data,
      companyuid,
      guid,
      last_bill_date_time: new Date(),
      days: 365, 
      sessiontoken,
      status: true,
      indexnumber: 1,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(serviceDocRef, servicequery);
    //accounts_company admin account

    const accounts_companyRef = doc(
      db,
      "companies",
      companyuid,
      "accounts_company",
      guid
    );
    // Check if document exists
    const existingSnap = await getDoc(accounts_companyRef);
    if (existingSnap.exists()) {
      // Skip writing 
    } else {
      // Create new document
      await setDoc(accounts_companyRef, {
        guid: guid,
        indexnumber: 1,
        accountguid: guid,
        companyuid: companyuid,
        sessiontoken: sessiontoken,
        city: Cookies.get("city") || "",
        postcode: Cookies.get("postcode") || "",
        state: Cookies.get("state") || "",
        country: Cookies.get("country") || "",
        latitude: Cookies.get("latitude") || "",
        longitude: Cookies.get("longitude") || "",
        deviceName: Cookies.get("deviceName") || "Unknown Device",
        device: navigator.userAgent,
        app_version: "1.1.5",
        status: true,
        date_time: new Date(),
      });
    }
    //staff_accounts admin account
    const staff_accounts_Ref = doc(
      db,
      "companies",
      companyuid,
      "staff_accounts",
      guid
    );
    // Check if document exists
    const staff_accountsexistingSnap = await getDoc(staff_accounts_Ref);
    if (staff_accountsexistingSnap.exists()) {
      // Skip writing 
    } else {
      // Create new document
      await setDoc(staff_accounts_Ref, {
        guid: guid,
              queue_verification: true,
      administration_login: true,
        indexnumber: 1,
        accountguid: guid,
        accountnumber: Randomnumber(8),
        account_type: "admin",
        description: "Administrator account",
        companyuid: companyuid,
        sessiontoken: sessiontoken,
        city: Cookies.get("city") || "",
        postcode: Cookies.get("postcode") || "",
        state: Cookies.get("state") || "",
        country: Cookies.get("country") || "",
        latitude: Cookies.get("latitude") || "",
        longitude: Cookies.get("longitude") || "",
        deviceName: Cookies.get("deviceName") || "Unknown Device",
        device: navigator.userAgent,
        app_version: "1.1.5",
        status: true,
        date_time: new Date(),
      });
    }
    //
  //  const domain = new URL(window.location.href).hostname; 
  //   // detect root domain (aooz.in)
  //   const parts = domain.split('.');
  //   const rootDomain =
  //     parts.length > 2
  //       ? parts.slice(parts.length - 2).join('.') // handle subdomains
  //       : domain;

    // Now store cookies under root domain
    // Cookies.set("select_company_uid", companyuid, {
    //   expires: 365,
    //   path: "/",
    //   domain: rootDomain
    // });
    //
    return { success: true };
  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
